import { useContext, useReducer, createContext, useCallback } from "react";
import { useRequest } from "../../services/request";

const Context = createContext();

export function useWebContent() {
  return useContext(Context);
}

const initState = {
  list: [],
  selected: null,
  filename: "",
  page: 1,
  perPage: 10,
  status: "idle",
  error: null,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "set_list":
      return { ...state, list: [...action.payload] };
    case "set_selected":
      return { ...state, selected: { ...action.payload } };
    case "set_count":
      return { ...state, count: action.payload };
    case "set_FileName":
      return { ...state, filename: action.payload };
    case "add":
      const newList = [{ ...action.payload }, ...state.list];
      return { ...state, list: newList };
    case "edit":
      const modified = state.list.map((p) =>
        p.id === action.payload.id ? { ...p, ...action.payload } : p
      );
      return { ...state, list: modified };
    case "delete":
      const filtered = state.list.filter((p) => p.id !== action.payload);
      return { ...state, list: filtered };
    case "status":
      return { ...state, status: action.payload };
    case "set_page":
      return { ...state, page: action.payload };
    case "set_per_page":
      return { ...state, perPage: action.payload };

    default:
      throw new Error(`Invalid dispatch type: ${action.type}`);
  }
};

export default function WebContentProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initState);
  const req = useRequest();

  const fetchOne = useCallback(
    (id) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: "status", payload: `fetching` });
          const resData = await req(
            `Site/WebContentInfo/${id}`,
            null,
            {},
            true
          );
          dispatch({ type: "set_selected", payload: resData.data });
          dispatch({ type: "status", payload: `idle` });
          resolve(resData);
        } catch (error) {
          reject(error);
        }
      });
    },
    [req]
  );
  const setWebContent = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        try {
          const resData = await req(
            `Site/SetWebContent/${id}`,
            data,
            { method: "PUT" },
            true
          );
          dispatch({ type: "status", payload: `idle` });

          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );
  const uploadPhoto = useCallback(
    async (data) => {
      let formData = new FormData();
      formData.append("file", data);

      return new Promise(async (resolve, reject) => {
        try {
          const resData = await req(
            "Upload/Image",
            formData,
            { method: "POST", headers: {} },
            true
          );

          resolve(resData.data);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
    },
    [req]
  );
  return (
    <Context.Provider
      value={{
        state,
        dispatch,
        fetchOne,
        setWebContent,
        uploadPhoto,
      }}
    >
      {children}
    </Context.Provider>
  );
}
